import axios from "axios";
import SideNavbar from "../../../components/common/SideNavbar";
import TopNavbar from "../../../components/common/TopNavbar";
import { useEffect, useState } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { userTableCustomStyles } from "../../../utils/TableCustomStyles";

function CurrencyExchangeRateMaster() {
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);
  const [dataPending, setDataPending] = useState(true);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] =
    useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const user_role = sessionStorage["userrole"];
  const user_id = sessionStorage["id"];
  const [loggedInUser, setLoggedInUser] = useState(null);

  // Canvas visibility
  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showUpdateCanvas, setShowUpdateCanvas] = useState(false);
  const [canvasAddFullScreen, setCanvasAddFullScreen] = useState(false);
  const [canvasUpdateFullScreen, setCanvasUpdateFullScreen] = useState(false);

  // Loaders
  const [showAddLoader, setShowAddLoader] = useState(false);
  const [showUpdateLoader, setShowUpdateLoader] = useState(false);
  const [showDeleteLoader, setShowDeleteLoader] = useState(false);

  const [recordForDelete, setRecordForDelete] = useState(null);

  // ---------- Add form state ----------
  const [fromCurrency, setFromCurrency] = useState("");
  const [toCurrency, setToCurrency] = useState("");
  const [exchangeRate, setExchangeRate] = useState("");
  const [lowerRate, setLowerRate] = useState("");
  const [upperRate, setUpperRate] = useState("");
  const [validFrom, setValidFrom] = useState("");

  // Add field errors
  const [showFromCurrencyError, setShowFromCurrencyError] = useState(false);
  const [showToCurrencyError, setShowToCurrencyError] = useState(false);
  const [showExchangeRateError, setShowExchangeRateError] = useState(false);
  const [showLowerRateError, setShowLowerRateError] = useState(false);
  const [showUpperRateError, setShowUpperRateError] = useState(false);
  const [showValidFromError, setShowValidFromError] = useState(false);

  // Add validation summary
  const [showValidationError, setShowValidationError] = useState(false);
  const [validationErrorArray, setValidationErrorArray] = useState([]);
  const [isValidationErrorVisible, setIsValidationErrorVisible] =
    useState(false);

  // ---------- Update form state ----------
  const [updateId, setUpdateId] = useState("");
  const [updateFromCurrency, setUpdateFromCurrency] = useState("");
  const [updateToCurrency, setUpdateToCurrency] = useState("");
  const [updateExchangeRate, setUpdateExchangeRate] = useState("");
  const [updateLowerRate, setUpdateLowerRate] = useState("");
  const [updateUpperRate, setUpdateUpperRate] = useState("");
  const [updateValidFrom, setUpdateValidFrom] = useState("");

  // Update field errors
  const [showUpdateFromCurrencyError, setShowUpdateFromCurrencyError] =
    useState(false);
  const [showUpdateToCurrencyError, setShowUpdateToCurrencyError] =
    useState(false);
  const [showUpdateExchangeRateError, setShowUpdateExchangeRateError] =
    useState(false);
  const [showUpdateLowerRateError, setShowUpdateLowerRateError] =
    useState(false);
  const [showUpdateUpperRateError, setShowUpdateUpperRateError] =
    useState(false);
  const [showUpdateValidFromError, setShowUpdateValidFromError] =
    useState(false);

  // Update validation summary
  const [showUpdateValidationError, setShowUpdateValidationError] =
    useState(false);
  const [updateValidationErrorArray, setUpdateValidationErrorArray] = useState(
    [],
  );
  const [isUpdateValidationErrorVisible, setIsUpdateValidationErrorVisible] =
    useState(false);

  // ========== Real‑time error helpers ==========
  const isValidNumber = (val) => val && !isNaN(val) && !isNaN(parseFloat(val));
  const isValidDate = (val) => /^\d{4}-\d{2}-\d{2}$/.test(val);

  const hasAnyAddError = () => {
    return (
      showFromCurrencyError ||
      showToCurrencyError ||
      showExchangeRateError ||
      showLowerRateError ||
      showUpperRateError ||
      showValidFromError
    );
  };

  const buildAddErrorMessages = () => {
    const errors = [];
    if (!fromCurrency) errors.push("From Currency is required");
    if (!toCurrency) errors.push("To Currency is required");
    if (!exchangeRate) errors.push("Exchange Rate is required");
    else if (!isValidNumber(exchangeRate))
      errors.push("Exchange Rate must be a valid number");
    if (!lowerRate) errors.push("Lower Rate is required");
    else if (!isValidNumber(lowerRate))
      errors.push("Lower Rate must be a valid number");
    if (!upperRate) errors.push("Upper Rate is required");
    else if (!isValidNumber(upperRate))
      errors.push("Upper Rate must be a valid number");
    if (!validFrom) errors.push("Valid From date is required");
    else if (!isValidDate(validFrom))
      errors.push("Valid From must be in YYYY-MM-DD format");
    return errors;
  };

  const hasAnyUpdateError = () => {
    return (
      showUpdateFromCurrencyError ||
      showUpdateToCurrencyError ||
      showUpdateExchangeRateError ||
      showUpdateLowerRateError ||
      showUpdateUpperRateError ||
      showUpdateValidFromError
    );
  };

  const buildUpdateErrorMessages = () => {
    const errors = [];
    if (!updateFromCurrency) errors.push("From Currency is required");
    if (!updateToCurrency) errors.push("To Currency is required");
    if (!updateExchangeRate) errors.push("Exchange Rate is required");
    else if (!isValidNumber(updateExchangeRate))
      errors.push("Exchange Rate must be a valid number");
    if (!updateLowerRate) errors.push("Lower Rate is required");
    else if (!isValidNumber(updateLowerRate))
      errors.push("Lower Rate must be a valid number");
    if (!updateUpperRate) errors.push("Upper Rate is required");
    else if (!isValidNumber(updateUpperRate))
      errors.push("Upper Rate must be a valid number");
    if (!updateValidFrom) errors.push("Valid From date is required");
    else if (!isValidDate(updateValidFrom))
      errors.push("Valid From must be in YYYY-MM-DD format");
    return errors;
  };

  // Tooltip toggles
  const handleCheckValidationClick = () =>
    setIsValidationErrorVisible(!isValidationErrorVisible);
  const handleUpdateCheckValidationClick = () =>
    setIsUpdateValidationErrorVisible(!isUpdateValidationErrorVisible);

  // ========== API calls ==========
  const getLoggedInUser = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/user/" + user_id,
      );
      setLoggedInUser(response.data);
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    }
  };

  const getCurrencyExchangeRate = async () => {
    try {
      setDataPending(true);
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/master/currencyexchangerate/",
      );
      setData(response.data);
    } catch (err) {
      toast.error("Error in fetching exchange rate data! Try again.");
    } finally {
      setDataPending(false);
    }
  };

  const getCurrency = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/currency/",
      );
      const sorted_data = response.data.sort((a, b) =>
        a.name.localeCompare(b.name),
      );
      setCurrencyList(sorted_data);
    } catch (err) {
      toast.error("Error in fetching currency data! Try again.");
    }
  };

  const getCurrentUserRolePermission = async (roles) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/role/getuserrolepermission?roles=" +
          roles,
      );
      const role_permissions_array = [];
      for (let i = 0; i < response.data?.length; i++) {
        for (let j = 0; j < response?.data[i]?.permissions_array?.length; j++) {
          if (
            !role_permissions_array.includes(
              response?.data[i]?.permissions_array?.[j],
            )
          ) {
            role_permissions_array.push(
              response?.data[i]?.permissions_array?.[j],
            );
          }
        }
      }
      setCurrentUserRolePermissionData(role_permissions_array);
    } catch (err) {
      toast.error("Error in fetching user role data! Try again.");
    }
  };

  useEffect(() => {
    getLoggedInUser();
    getCurrencyExchangeRate();
    getCurrency();
  }, []);

  useEffect(() => {
    getCurrentUserRolePermission(user_role);
  }, [user_role]);

  // ========== Delete handlers ==========
  const handleDeleteModalClose = () => setShowDeleteModal(false);
  const handleDeleteModalOpen = (data) => {
    setShowDeleteModal(true);
    setRecordForDelete(data);
  };

  const deleteSelectedRecord = async (id) => {
    setShowDeleteLoader(true);
    try {
      await axios.delete(
        process.env.REACT_APP_BACKEND_API_URL +
          "/master/currencyexchangerate/" +
          id +
          "/",
      );
      setShowDeleteModal(false);
      getCurrencyExchangeRate();
      toast.success("Record deleted successfully");
    } catch (err) {
      toast.error("Error in deleting record! Try again.");
    }
    setShowDeleteLoader(false);
  };

  // ========== Add logic ==========
  const resetAddForm = () => {
    setFromCurrency("");
    setToCurrency("");
    setExchangeRate("");
    setLowerRate("");
    setUpperRate("");
    setValidFrom("");
    setShowFromCurrencyError(false);
    setShowToCurrencyError(false);
    setShowExchangeRateError(false);
    setShowLowerRateError(false);
    setShowUpperRateError(false);
    setShowValidFromError(false);
    setShowValidationError(false);
    setValidationErrorArray([]);
    setIsValidationErrorVisible(false);
  };

  const handleAddModalClose = () => {
    resetAddForm();
    setShowAddCanvas(false);
    setCanvasAddFullScreen(false);
  };

  const addNewCurrencyExchangeRate = async (e) => {
    e.preventDefault();

    // Update error flags
    setShowFromCurrencyError(!fromCurrency);
    setShowToCurrencyError(!toCurrency);
    setShowExchangeRateError(!exchangeRate || !isValidNumber(exchangeRate));
    setShowLowerRateError(!lowerRate || !isValidNumber(lowerRate));
    setShowUpperRateError(!upperRate || !isValidNumber(upperRate));
    setShowValidFromError(!validFrom || !isValidDate(validFrom));
    setValidationErrorArray(buildAddErrorMessages());

    if (
      !fromCurrency ||
      !toCurrency ||
      !exchangeRate ||
      !lowerRate ||
      !upperRate ||
      !validFrom ||
      !isValidNumber(exchangeRate) ||
      !isValidNumber(lowerRate) ||
      !isValidNumber(upperRate) ||
      !isValidDate(validFrom)
    ) {
      setShowValidationError(true);
      return;
    }

    setShowAddLoader(true);

    const payload = {
      from_currency: fromCurrency,
      to_currency: toCurrency,
      exchange_rate: parseFloat(exchangeRate),
      lower_rate: parseFloat(lowerRate),
      upper_rate: parseFloat(upperRate),
      valid_from: validFrom,
      created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    try {
      const response = await axios.post(
        process.env.REACT_APP_BACKEND_API_URL + "/master/currencyexchangerate/",
        payload,
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 200 || response.status === 201) {
        toast.success("Exchange Rate Created Successfully");
        handleAddModalClose();
        getCurrencyExchangeRate();
      }
    } catch (err) {
      toast.error("Error creating exchange rate");
    } finally {
      setShowAddLoader(false);
    }
  };

  // ========== Update logic ==========
  const resetUpdateForm = () => {
    setUpdateId("");
    setUpdateFromCurrency("");
    setUpdateToCurrency("");
    setUpdateExchangeRate("");
    setUpdateLowerRate("");
    setUpdateUpperRate("");
    setUpdateValidFrom("");
    setShowUpdateFromCurrencyError(false);
    setShowUpdateToCurrencyError(false);
    setShowUpdateExchangeRateError(false);
    setShowUpdateLowerRateError(false);
    setShowUpdateUpperRateError(false);
    setShowUpdateValidFromError(false);
    setShowUpdateValidationError(false);
    setUpdateValidationErrorArray([]);
    setIsUpdateValidationErrorVisible(false);
  };

  const handleUpdateModalClose = () => {
    resetUpdateForm();
    setShowUpdateCanvas(false);
    setCanvasUpdateFullScreen(false);
  };

  const handleSetUpdateData = (row) => {
    setUpdateId(row.id);
    setUpdateFromCurrency(row.from_currency);
    setUpdateToCurrency(row.to_currency);
    setUpdateExchangeRate(row.exchange_rate?.toString() || "");
    setUpdateLowerRate(row.lower_rate?.toString() || "");
    setUpdateUpperRate(row.upper_rate?.toString() || "");
    setUpdateValidFrom(row.valid_from || "");
    // Reset errors when opening
    setShowUpdateFromCurrencyError(false);
    setShowUpdateToCurrencyError(false);
    setShowUpdateExchangeRateError(false);
    setShowUpdateLowerRateError(false);
    setShowUpdateUpperRateError(false);
    setShowUpdateValidFromError(false);
    setShowUpdateValidationError(false);
    setUpdateValidationErrorArray([]);
  };

  const updateCurrencyExchangeRate = async (e) => {
    e.preventDefault();

    setShowUpdateFromCurrencyError(!updateFromCurrency);
    setShowUpdateToCurrencyError(!updateToCurrency);
    setShowUpdateExchangeRateError(
      !updateExchangeRate || !isValidNumber(updateExchangeRate),
    );
    setShowUpdateLowerRateError(
      !updateLowerRate || !isValidNumber(updateLowerRate),
    );
    setShowUpdateUpperRateError(
      !updateUpperRate || !isValidNumber(updateUpperRate),
    );
    setShowUpdateValidFromError(
      !updateValidFrom || !isValidDate(updateValidFrom),
    );
    setUpdateValidationErrorArray(buildUpdateErrorMessages());

    if (
      !updateFromCurrency ||
      !updateToCurrency ||
      !updateExchangeRate ||
      !updateLowerRate ||
      !updateUpperRate ||
      !updateValidFrom ||
      !isValidNumber(updateExchangeRate) ||
      !isValidNumber(updateLowerRate) ||
      !isValidNumber(updateUpperRate) ||
      !isValidDate(updateValidFrom)
    ) {
      setShowUpdateValidationError(true);
      return;
    }

    setShowUpdateLoader(true);

    const payload = {
      from_currency: updateFromCurrency,
      to_currency: updateToCurrency,
      exchange_rate: parseFloat(updateExchangeRate),
      lower_rate: parseFloat(updateLowerRate),
      upper_rate: parseFloat(updateUpperRate),
      valid_from: updateValidFrom,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL +
          "/master/currencyexchangerate/" +
          updateId +
          "/",
        payload,
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 200 || response.status === 201) {
        toast.success("Exchange Rate Updated Successfully");
        handleUpdateModalClose();
        getCurrencyExchangeRate();
      }
    } catch (err) {
      toast.error("Error updating exchange rate");
    } finally {
      setShowUpdateLoader(false);
    }
  };

  // ========== Table columns ==========
  const columns = [
    {
      name: "From Currency",
      selector: (row) => row.from_currency_data?.name,
      sortable: true,
    },
    {
      name: "To Currency",
      selector: (row) => row.to_currency_data?.name,
      sortable: true,
    },
    {
      name: "Exchange Rate",
      selector: (row) => row.exchange_rate,
      sortable: true,
    },
    { name: "Lower Rate", selector: (row) => row.lower_rate, sortable: true },
    { name: "Upper Rate", selector: (row) => row.upper_rate, sortable: true },
    { name: "Valid From", selector: (row) => row.valid_from, sortable: true },
    {
      name: "Action",
      center: true,
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes("master:customer:update") ? (
            <Button
              className="btn btn-sm btn-inox-green border-0"
              title="Update"
              onClick={() => {
                handleSetUpdateData(row);
                setShowUpdateCanvas(true);
              }}
            >
              <i className="fa fa-edit"></i>
            </Button>
          ) : (
            ""
          )}
          {currentUserRolePermissionData?.includes("master:customer:delete") ? (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => handleDeleteModalOpen(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          ) : (
            ""
          )}
        </div>
      ),
    },
  ];

  const handleDataFromTopNavBar = (permissiondata) =>
    setDataFromTopNavBar(permissiondata);

  return (
    <div className="page-content-bg">
      <ToastContainer />
      <TopNavbar
        sidebarCollapsed={menuDrawerShow}
        topNavbarStatic={true}
        sendDataToParent={handleDataFromTopNavBar}
      />
      <SideNavbar
        sidebarCollapsed={menuDrawerShow}
        activeMenu="Master"
        activeSubMenu="AdminMaster"
        activeSubMenuLevel1="CurrencyExchangeRateMaster"
        permissionFromTopNavbar={dataFromTopNavBar}
      />

      <div
        className={
          menuDrawerShow
            ? "row main-content-collapsed text-left py-0"
            : "row main-content text-left py-0"
        }
      >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-6 py-1">
              <Button
                className="btn btn-sm btn-inox-green border-0 mx-2"
                onClick={() => setMenuDrawerShow(!menuDrawerShow)}
              >
                {menuDrawerShow ? (
                  <span>
                    <i className="fa fa-chevron-left mx-1"></i>
                  </span>
                ) : (
                  <span>
                    <i className="fa fa-chevron-right mx-1"></i>
                  </span>
                )}
              </Button>
              <span className="page-header-text">
                Currency Exchange Rate Master
              </span>
            </div>
            <div className="col-6 py-1" style={{ paddingRight: 30 }}>
              {currentUserRolePermissionData?.includes(
                "master:customer:add",
              ) ? (
                <Button
                  className="btn btn-sm btn-inox-green border-0 px-3 float-right"
                  onClick={() => {
                    resetAddForm();
                    setShowAddCanvas(true);
                  }}
                >
                  <i
                    className="fa fa-plus fa-lg text-right"
                    style={{ paddingRight: 10 }}
                  ></i>
                  <span className="fw-bold">Add Exchange Rate</span>
                </Button>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        <div
          className="col-12 text-left"
          style={{
            marginTop: -5,
            paddingLeft: 20,
            paddingRight: 30,
            zIndex: 100,
          }}
        >
          <DataTable
            columns={columns}
            data={data}
            progressPending={dataPending}
            progressComponent={
              <Spinner
                className="mx-5 text-inox-green table-spinner"
                as="span"
                animation="border"
                size="lg"
                role="status"
                aria-hidden="true"
              />
            }
            noDataComponent={
              <p className="text-center table-no-data">No Data Found</p>
            }
            pagination
            highlightOnHover
            fixedHeader
            customStyles={userTableCustomStyles}
            dense
          />
        </div>
      </div>

      {/* Delete Modal */}
      <Modal
        size="sm"
        show={showDeleteModal}
        onHide={handleDeleteModalClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModalClose}>
            Close
          </Button>
          <Button
            variant="danger"
            onClick={() => deleteSelectedRecord(recordForDelete?.id)}
          >
            {showDeleteLoader ? (
              <Spinner
                className="mx-3 text-white"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ------------------------ Update Canvas ------------------- */}
      <div
        className={
          canvasUpdateFullScreen && showUpdateCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasUpdateFullScreen && showUpdateCanvas
              ? "offcanvas offcanvas-bottom h-50 show"
              : "offcanvas offcanvas-bottom h-50"
        }
        tabIndex="-1"
        aria-labelledby="updateCanvasLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="updateCanvasLabel" className="float-left">
                Update Record
              </h4>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                aria-label="Close"
                title="Close"
                onClick={handleUpdateModalClose}
              >
                <i className="fa fa-times text-white"></i>
              </button>
              {canvasUpdateFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => setCanvasUpdateFullScreen(false)}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => setCanvasUpdateFullScreen(true)}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div
          className="offcanvas-body"
          style={{ paddingLeft: 20, paddingRight: 40 }}
        >
          <form onSubmit={updateCurrencyExchangeRate}>
            <div className="row">
              {/* From Currency */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label
                  className="required-label"
                  htmlFor="update_from_currency"
                >
                  From Currency:
                  <span className="text-danger">
                    {showUpdateFromCurrencyError ? " Currency required" : ""}
                  </span>
                </label>
                <select
                  className="form-select form-select-sm"
                  id="update_from_currency"
                  value={updateFromCurrency}
                  onChange={(e) => {
                    setUpdateFromCurrency(e.target.value);
                    setShowUpdateFromCurrencyError(false);
                    setShowUpdateValidationError(false);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowUpdateFromCurrencyError(e.target.value === "");
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                >
                  <option value="">Select Currency</option>
                  {currencyList.map((currency) => (
                    <option key={currency.id} value={currency.id}>
                      {currency.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* To Currency */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="update_to_currency">
                  To Currency:
                  <span className="text-danger">
                    {showUpdateToCurrencyError ? " Currency required" : ""}
                  </span>
                </label>
                <select
                  className="form-select form-select-sm"
                  id="update_to_currency"
                  value={updateToCurrency}
                  onChange={(e) => {
                    setUpdateToCurrency(e.target.value);
                    setShowUpdateToCurrencyError(false);
                    setShowUpdateValidationError(false);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowUpdateToCurrencyError(e.target.value === "");
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                >
                  <option value="">Select Currency</option>
                  {currencyList.map((currency) => (
                    <option key={currency.id} value={currency.id}>
                      {currency.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Exchange Rate */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label
                  className="required-label"
                  htmlFor="update_exchange_rate"
                >
                  Exchange Rate:
                  <span className="text-danger">
                    {showUpdateExchangeRateError
                      ? updateExchangeRate
                        ? "Must be a valid number"
                        : "Required"
                      : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="update_exchange_rate"
                  placeholder="Enter Exchange Rate"
                  value={updateExchangeRate}
                  onChange={(e) => {
                    setUpdateExchangeRate(e.target.value);
                    setShowUpdateExchangeRateError(false);
                    setShowUpdateValidationError(false);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                  onBlur={(e) => {
                    const val = e.target.value;
                    setShowUpdateExchangeRateError(!val || !isValidNumber(val));
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                />
              </div>

              {/* Lower Rate */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="update_lower_rate">
                  Lower Rate:
                  <span className="text-danger">
                    {showUpdateLowerRateError
                      ? updateLowerRate
                        ? "Must be a valid number"
                        : "Required"
                      : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="update_lower_rate"
                  placeholder="Enter Lower Rate"
                  value={updateLowerRate}
                  onChange={(e) => {
                    setUpdateLowerRate(e.target.value);
                    setShowUpdateLowerRateError(false);
                    setShowUpdateValidationError(false);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                  onBlur={(e) => {
                    const val = e.target.value;
                    setShowUpdateLowerRateError(!val || !isValidNumber(val));
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                />
              </div>

              {/* Upper Rate */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="update_upper_rate">
                  Upper Rate:
                  <span className="text-danger">
                    {showUpdateUpperRateError
                      ? updateUpperRate
                        ? "Must be a valid number"
                        : "Required"
                      : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="update_upper_rate"
                  placeholder="Enter Upper Rate"
                  value={updateUpperRate}
                  onChange={(e) => {
                    setUpdateUpperRate(e.target.value);
                    setShowUpdateUpperRateError(false);
                    setShowUpdateValidationError(false);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                  onBlur={(e) => {
                    const val = e.target.value;
                    setShowUpdateUpperRateError(!val || !isValidNumber(val));
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                />
              </div>

              {/* Valid From */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="update_valid_from">
                  Valid From:
                  <span className="text-danger">
                    {showUpdateValidFromError
                      ? updateValidFrom
                        ? "Must be YYYY-MM-DD"
                        : "Required"
                      : ""}
                  </span>
                </label>
                <input
                  type="date"
                  className="form-control form-control-sm"
                  id="update_valid_from"
                  value={updateValidFrom}
                  onChange={(e) => {
                    setUpdateValidFrom(e.target.value);
                    setShowUpdateValidFromError(false);
                    setShowUpdateValidationError(false);
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                  onBlur={(e) => {
                    const val = e.target.value;
                    setShowUpdateValidFromError(!val || !isValidDate(val));
                    setUpdateValidationErrorArray(buildUpdateErrorMessages());
                  }}
                />
              </div>

              {/* Submit Button + Error Tooltip */}
              <div
                className={`form-group ${canvasUpdateFullScreen ? "col-md-12" : "col-md-12"}`}
              >
                {" "}
                <div className="canvas-btn-row">
                  <Button
                    type="submit"
                    className="btn btn-inox-green border-0 canvas-button"
                    disabled={hasAnyUpdateError() || showUpdateLoader}
                  >
                    {showUpdateLoader ? (
                      <Spinner
                        className="mx-4"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <>
                        <i className="fa fa-edit"></i>{" "}
                        <span className="mx-2">Update</span>
                      </>
                    )}
                  </Button>

                  {(hasAnyUpdateError() || showUpdateValidationError) && (
                    <div className="error-tooltip-wrapper">
                      <Button
                        style={{
                          backgroundColor: "#C21E22",
                          border: "#f82e2e",
                        }}
                        title="Show Errors"
                        className="mx-2"
                        onClick={handleUpdateCheckValidationClick}
                        onMouseLeave={() =>
                          setIsUpdateValidationErrorVisible(false)
                        }
                      >
                        <i className="fa fa-exclamation"></i>
                      </Button>
                      {isUpdateValidationErrorVisible && (
                        <div className="validation-error-tooltip">
                          <ul className="mb-0 px-4">
                            {updateValidationErrorArray.map((error, index) => (
                              <li key={index} className="text-left small pb-0">
                                {error}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* ------------------------ Add Canvas ------------------- */}
      <div
        className={
          canvasAddFullScreen && showAddCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasAddFullScreen && showAddCanvas
              ? "offcanvas offcanvas-bottom h-50 show"
              : "offcanvas offcanvas-bottom h-50"
        }
        tabIndex="-1"
        aria-labelledby="addCanvasLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="addCanvasLabel" className="float-left">
                Add New Record
              </h4>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                aria-label="Close"
                title="Close"
                onClick={handleAddModalClose}
              >
                <i className="fa fa-times text-white"></i>
              </button>
              {canvasAddFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => setCanvasAddFullScreen(false)}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => setCanvasAddFullScreen(true)}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div
          className="offcanvas-body"
          style={{ paddingLeft: 20, paddingRight: 40 }}
        >
          <form onSubmit={addNewCurrencyExchangeRate}>
            <div className="row">
              {/* From Currency */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_from_currency">
                  From Currency:
                  <span className="text-danger">
                    {showFromCurrencyError ? " Currency required" : ""}
                  </span>
                </label>
                <select
                  className="form-select form-select-sm"
                  id="add_from_currency"
                  value={fromCurrency}
                  onChange={(e) => {
                    setFromCurrency(e.target.value);
                    setShowFromCurrencyError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowFromCurrencyError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                >
                  <option value="">Select Currency</option>
                  {currencyList.map((currency) => (
                    <option key={currency.id} value={currency.id}>
                      {currency.name}
                    </option>
                  ))}
                </select>
              </div>
              {/* To Currency */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_to_currency">
                  To Currency:
                  <span className="text-danger">
                    {showToCurrencyError ? " Currency required" : ""}
                  </span>
                </label>
                <select
                  className="form-select form-select-sm"
                  id="add_to_currency"
                  value={toCurrency}
                  onChange={(e) => {
                    setToCurrency(e.target.value);
                    setShowToCurrencyError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowToCurrencyError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                >
                  <option value="">Select Currency</option>
                  {currencyList.map((currency) => (
                    <option key={currency.id} value={currency.id}>
                      {currency.name}
                    </option>
                  ))}
                </select>
              </div>
              {/* Exchange Rate */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_exchange_rate">
                  Exchange Rate:
                  <span className="text-danger">
                    {showExchangeRateError
                      ? exchangeRate
                        ? "Must be a valid number"
                        : "Required"
                      : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_exchange_rate"
                  placeholder="Enter Exchange Rate"
                  value={exchangeRate}
                  onChange={(e) => {
                    setExchangeRate(e.target.value);
                    setShowExchangeRateError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    const val = e.target.value;
                    setShowExchangeRateError(!val || !isValidNumber(val));
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>
              {/* Lower Rate */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_lower_rate">
                  Lower Rate:
                  <span className="text-danger">
                    {showLowerRateError
                      ? lowerRate
                        ? "Must be a valid number"
                        : "Required"
                      : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_lower_rate"
                  placeholder="Enter Lower Rate"
                  value={lowerRate}
                  onChange={(e) => {
                    setLowerRate(e.target.value);
                    setShowLowerRateError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    const val = e.target.value;
                    setShowLowerRateError(!val || !isValidNumber(val));
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>
              {/* Upper Rate */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_upper_rate">
                  Upper Rate:
                  <span className="text-danger">
                    {showUpperRateError
                      ? upperRate
                        ? "Must be a valid number"
                        : "Required"
                      : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_upper_rate"
                  placeholder="Enter Upper Rate"
                  value={upperRate}
                  onChange={(e) => {
                    setUpperRate(e.target.value);
                    setShowUpperRateError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    const val = e.target.value;
                    setShowUpperRateError(!val || !isValidNumber(val));
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>
              {/* Valid From */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_valid_from">
                  Valid From:
                  <span className="text-danger">
                    {showValidFromError
                      ? validFrom
                        ? "Must be YYYY-MM-DD"
                        : "Required"
                      : ""}
                  </span>
                </label>
                <input
                  type="date"
                  className="form-control form-control-sm"
                  id="add_valid_from"
                  value={validFrom}
                  onChange={(e) => {
                    setValidFrom(e.target.value);
                    setShowValidFromError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    const val = e.target.value;
                    setShowValidFromError(!val || !isValidDate(val));
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>
              {/* Submit Button + Error Tooltip */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-12" : "col-md-12"}`}
              >
                {" "}
                <div className="canvas-btn-row">
                  <Button
                    type="submit"
                    className="btn btn-inox-green border-0 canvas-button"
                    disabled={hasAnyAddError() || showAddLoader}
                  >
                    {showAddLoader ? (
                      <Spinner
                        className="mx-4"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <>
                        <i className="fa fa-plus"></i>{" "}
                        <span className="mx-2">Add</span>
                      </>
                    )}
                  </Button>

                  {(hasAnyAddError() || showValidationError) && (
                    <div className="error-tooltip-wrapper">
                      <Button
                        style={{
                          backgroundColor: "#C21E22",
                          border: "#f82e2e",
                        }}
                        title="Show Errors"
                        className="mx-2"
                        onClick={handleCheckValidationClick}
                        onMouseLeave={() => setIsValidationErrorVisible(false)}
                      >
                        <i className="fa fa-exclamation"></i>
                      </Button>
                      {isValidationErrorVisible && (
                        <div className="validation-error-tooltip">
                          <ul className="mb-0 px-4">
                            {validationErrorArray.map((error, index) => (
                              <li key={index} className="text-left small pb-0">
                                {error}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CurrencyExchangeRateMaster;
